import { useHistory } from "react-router-dom";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";

export const LogoutCallback = () => {
    const history = useHistory();

    history.push("/");

    return <AbpnSpinner></AbpnSpinner>
}